import {RegistryManager} from "./registrymanager.mjs";

export class Controller{
    constructor(view ){
        var _registryManager = new RegistryManager();
        var _view = view ;
        var _controllerManager; 

        Object.defineProperty(this,'getRegistryManager',{
            value : ()=>_registryManager
        });

        Object.defineProperty(this,'view',{
            set : (v)=>{ _view = v },
            get : ()=>_view
        });

        Object.defineProperty(this,'controllerManager',{
            set : function(m){ _controllerManager = m },
            get : function(){ return _controllerManager }
        })


    }
    // ==========
    // private 
    // ----------

    getView(){ return this.view }

    setView(v){ this.view = v }

    register(name, createFn){
        var registryManager = this.getRegistryManager();
        registryManager.addCreateFn(name, createFn);
    }
    registerEventDefineListener(name, eventDefineListener){
        var registryManager = this.getRegistryManager();
        registryManager.addEventDefineListener(name, eventDefineListener);
    }

    clearEventDefineListener(name){ 
        var registryManager = this.getRegistryManager();
        var registryEntry = registryManager.registryMap.get(name)
        var component = registryEntry.getComponent()
        var eventManager = component.getEventManager();
        
        registryEntry.getEventDefineListeners().forEach(array =>{
            var event = array[0];
            var handler = array[2];
            console.log(event, handler);
            eventManager.removeEventSpecifier(event, handler)
        })
        registryManager.clearEventDefineListener(name);
    }

    createComponent(name, ...params){
        var registryManager = this.getRegistryManager();
        var component = registryManager.getCreateFn(name).call(this,...params);
        var eventDefineListeners = registryManager.getEventDefineListeners(name);
        eventDefineListeners.forEach(eventDefineListener =>{
            var eventManager = component.getEventManager();
            eventManager.on.apply(eventManager, eventDefineListener);
        });
        component.updateManagerListeners();
        registryManager.setComponent(name,component);
        return component;
    }

    getComponent(name){
        var registryManager = this.getRegistryManager();
        return registryManager.getComponent(name);        
    }

    addToView(componentName, selector){  // TMP. selector should not be done here, but in the view
        var view = this.getView();
        var component = this.getComponent(componentName);
        view.addSubComponent(component,componentName,selector); 
    }

    removeFromView(componentName){
        var view = this.getView();
        view.removeSubComponent(componentName);
    }

    // ==========
    // public 
    // ---------- 

}